import type {IssueField} from '../api/common-contracts'
import type {ColumnModel} from '../models/column-model'
import {areColumnNamesEqual} from '../validations/validate-column-title'

export function checkFieldCollision(
  issueField: IssueField,
  allColumns: ReadonlyArray<ColumnModel> | null,
): ColumnModel | null {
  if (!allColumns) return null

  for (const column of allColumns) {
    if (column.isIssueField) continue

    if (areColumnNamesEqual(issueField.name, column.name)) {
      return column
    }
  }

  return null
}
